export default {
  employeeTags: {},
};
